import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Tooltip } from '@telus-uds/components-web';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';

import Overlay from './overlay';

const DeleteButton = ({ id, fetchData }) => {
  const [inDeleteMode, setInDeleteMode] = useState(false);

  return (
    <>
      <Tooltip content="Delete">
        <Button
          icon={Delete}
          onPress={() => {
            setInDeleteMode(true);
          }}
          accessibilityLabel="Delete"
          variant={{ text: true }}
        />
      </Tooltip>
      {inDeleteMode && (
        <Overlay
          id={id}
          fetchData={fetchData}
          setInDeleteMode={setInDeleteMode}
        />
      )}
    </>
  );
};

DeleteButton.propTypes = {
  id: PropTypes.number.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default DeleteButton;
